<script setup lang="ts">
import { computed } from 'vue'
import type { HelpModuleConfig } from '@/types/help'
import {
  Rocket,
  LayoutDashboard,
  Building2,
  FolderKanban,
  ListTodo,
  ClipboardList,
  Layers,
  MessageSquarePlus,
  Ticket,
  PackageCheck,
  Users,
  Calendar,
  Video,
  FileText,
  Receipt,
  ShoppingCart,
  UserCog,
  Settings,
  Bot,
  Shield,
} from 'lucide-vue-next'

const props = defineProps<{
  module: HelpModuleConfig
  x: number
  y: number
  rotation: number
  scale: number
  delay: number
}>()

defineEmits<{
  click: []
}>()

const iconMap: Record<string, unknown> = {
  Rocket,
  LayoutDashboard,
  Building2,
  FolderKanban,
  ListTodo,
  ClipboardList,
  Layers,
  MessageSquarePlus,
  Ticket,
  PackageCheck,
  Users,
  Calendar,
  Video,
  FileText,
  Receipt,
  ShoppingCart,
  UserCog,
  Settings,
  Bot,
  Shield,
}

const icon = computed(() => iconMap[props.module.icon] || FileText)

const style = computed(() => ({
  left: `${props.x}px`,
  top: `${props.y}px`,
  transform: `rotate(${props.rotation}deg) scale(${props.scale})`,
  animationDelay: `${props.delay}ms`,
}))
</script>

<template>
  <div
    class="floating-card absolute p-3 bg-background/95 backdrop-blur border rounded-xl shadow-lg
           cursor-pointer select-none transition-all duration-200
           hover:scale-110 hover:shadow-xl hover:border-primary/50 hover:z-10"
    :style="style"
    @click="$emit('click')"
  >
    <div class="flex items-center gap-2.5">
      <div
        class="h-9 w-9 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0"
      >
        <component :is="icon" class="h-4.5 w-4.5 text-primary" />
      </div>
      <span class="font-medium text-sm whitespace-nowrap">{{ module.title }}</span>
    </div>
  </div>
</template>

<style scoped>
.floating-card {
  animation: float-drift 8s ease-in-out infinite;
}

@keyframes float-drift {
  0%, 100% {
    transform: translate(0, 0) rotate(var(--rotation, 0deg)) scale(var(--scale, 1));
  }
  25% {
    transform: translate(8px, -12px) rotate(calc(var(--rotation, 0deg) + 2deg)) scale(var(--scale, 1));
  }
  50% {
    transform: translate(-4px, 8px) rotate(calc(var(--rotation, 0deg) - 1deg)) scale(var(--scale, 1));
  }
  75% {
    transform: translate(12px, 4px) rotate(calc(var(--rotation, 0deg) + 1deg)) scale(var(--scale, 1));
  }
}
</style>
